var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-banner",style:({ 'background-image': `url(${_vm.backgroundImage})` })},[_c('div',{staticClass:"top-banner-box"},[_c('div',{staticClass:"tips-text"},[_vm._v("Best Airfares Guaranteed")]),_c('top-form',{attrs:{"dataForm":_vm.dataForm,"markPage":_vm.markPage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }